//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React from 'react'

import '@react/App.css'
import { BrowserRouter } from 'react-router-dom'

import { ErrorBoundary } from './ErrorBoundary'
import { LicenseInfo } from '@mui/x-license-pro'

import { SagaNavigationWrapper } from './SagaNavigationWrapper'
import UnconnectedRouting from './UnconnectedRouting'
import { useTheme } from '@mui/material'

LicenseInfo.setLicenseKey(
  '4aa820c74354bf0194df6f7dfa013a7fTz0xMTE4ODYsRT0xNzc3MDc1MTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
)

function UnconnectedApp(props: { transferLocation?: string }): React.ReactElement {
  const theme = useTheme()
  document.title = 'OpenTrade'

  return (
    <div
      data-testid="UnconnectedApp"
      className="App"
      style={{
        height: '100%',
        minHeight: '100vh',
        backgroundColor: theme.palette.background.canvas,
        overflow: 'scroll',
      }}
    >
      <title>OpenTrade </title>

      <BrowserRouter>
        <SagaNavigationWrapper>
          <ErrorBoundary>
            <UnconnectedRouting transferLocation={props.transferLocation} />
          </ErrorBoundary>
        </SagaNavigationWrapper>
      </BrowserRouter>
    </div>
  )
}

export default UnconnectedApp
